import { equals } from 'ramda';

import { actionTypes } from './../actions';

// eslint-disable-next-line import/no-anonymous-default-export
export default createStore => (reducer, initialState, enhancer) => {
    const resetReducer = (state, action) => {
        if (equals(action.type, actionTypes.LOGOUT)) {
            state = undefined;
        }
        return reducer(state, action);
    };

    return createStore(resetReducer, initialState, enhancer);
};
